import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import plugin from './plugin/index'
import store from './store'
import i18n from './lang'
import Print from 'vue-print-nb'

//vue-socket.io实现在线聊天
// import VueSocketIO from 'vue-socket.io'
// Vue.use(new VueSocketIO({
//   debug: true,
//   connection: `${process.env.SOCKET_URL}`,
//   vuex: {
//     store,
//     actionPrefix: 'SOCKET_',
//     mutationPrefix: 'SOCKET_'
//   },
//   options: { path: "" } //Optional options
// }))
import echarts from 'echarts'
Vue.prototype.$echarts = echarts
Vue.use(plugin)
Vue.use(Print)
// import risize from '@/layout/Home/mixin/RisizeTable'
// Vue.mixin(risize)
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js